import React from "react";
import Button from "../../../../components/Button";
import PropTypes from "prop-types";
import { Users as GroupIcon } from "react-feather";
import i18next from "i18next";

const CreateGroup = ({ onClick }) => {
    return (
        <section id="create-group-section" className="create-grp">
            <div className="create-grp__content">
                <GroupIcon />
                <div className="create-grp__info">
                    <span>{i18next.t("cart.createGroup.title")}</span>
                    <p>{i18next.t("cart.createGroup.info")}</p>
                </div>
            </div>
            <div className="create-grp__cta">
                <Button
                    label={i18next.t("cart.createGroup.cta")}
                    onClick={onClick}
                    variant={"secondary"}
                    size="XS"
                />
            </div>
        </section>
    );
};

CreateGroup.propTypes = {
    onClick: PropTypes.func,
};
export default CreateGroup;
